import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { Box, Button, Tooltip } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MuiAlert from "@mui/material/Alert";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function Technology(props) {
  const { state, onState, handleNext, classes, lablist } = props;
  const [temporary, settemporary] = useState({});
  const [find, setfind] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [ShowNoofTraineeAlert, setShowNoofTraineeAlert] = useState(false); // Changed to false
  const [startWithHyphen, setStartWithHyphen] = useState(false);

  const handleReload = () => {
    window.location.reload();
  };

  const preventInvalidKeyInput = (e) => {
    // Block +, -, e, E, . (for number input)
    if (['+', '-', 'e', 'E', '.'].includes(e.key)) {
      e.preventDefault();
    }
    
    // Prevent entering more digits if already at max
    if (e.target.value.length >= 2 && e.key !== 'Backspace' && e.key !== 'Delete') {
      e.preventDefault();
    }
  };

  const handleChange1 = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    const numericValue = Number(value);

    // Check if the value is a positive multiple of 4
    if (numericValue > 0 && numericValue % 4 === 0) {
      setShowNoofTraineeAlert(false);
      onState((prevState) => ({
        ...prevState,
        [id]: numericValue,
      }));
      settemporary((prevState) => ({
        ...prevState,
        [id]: numericValue,
      }));
    } else {
      setShowNoofTraineeAlert(true);
    }
  };

  const handleLabNameChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    setfind(false);
    setStartWithHyphen(false);

    if (value.startsWith('-')) {
      setStartWithHyphen(true);
    } else {
      const labExists = lablist.some((instance) => instance.name === value);
      if (labExists) {
        setfind(true);
      }
    }

    onState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleKeyPress = (event) => {
    if (event.key === '_') {
      event.preventDefault();
    }
  };

  const handle_budgetKeyPress = (event) => {
    const restrictedCharacters = ['_', '-', '%'];
    if (restrictedCharacters.includes(event.key)) {
      event.preventDefault();
    }
  };

  const handleDescriptionChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    onState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  useEffect(() => {
    setShowAlert(temporary.name && !/^[a-z0-9_\-]{1,15}$/.test(temporary.name));
  }, [temporary.name]);

  const isNextButtonDisabled = !(
    temporary.name &&
    temporary.nooftrainee &&
    !find &&
    !showAlert &&
    !ShowNoofTraineeAlert &&
    !startWithHyphen
  );

  return (
    <React.Fragment>
      <Box sx={{ pb: 2 }}>
        <Typography variant="h6" gutterBottom>
          Create Lab
        </Typography>
      </Box>
      {showAlert && (
        <Box sx={{ pb: 2 }}>
          <Alert severity="warning">
            Please Enter the lower case letters and Only 15 characters allow
          </Alert>
        </Box>
      )}

      <Grid container spacing={4}>
        <Grid item md={6} xs={12}>
          <InputLabel>
            Name<small style={{ paddingLeft: "10px" }}>required</small>
            <small style={{ color: "red" }}>*</small>
          </InputLabel>
          <TextField
            fullWidth
            helperText={
              startWithHyphen
                ? "Name cannot start with a hyphen"
                : find
                ? "Lab name already exists, Please enter a unique name"
                : "Please specify the name"
            }
            name="name"
            id="name"
            color={temporary.name && !find && !startWithHyphen ? "success" : ""}
            error={find || startWithHyphen}
            onChange={handleLabNameChange}
            onKeyPress={handleKeyPress}
            required
            autoComplete="name"
            InputProps={{
              style: {
                height: "40px",
              },
            }}
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <InputLabel>
            Number of Trainee
            <small style={{ paddingLeft: "10px" }}>required</small>
            <small style={{ color: "red" }}>*</small>
          </InputLabel>
          <TextField
            fullWidth
            size="small"
            name="nooftrainee"
            onKeyDown={preventInvalidKeyInput}
            id="nooftrainee"
            color={!ShowNoofTraineeAlert ? "success" : "error"}
            type="number"
            error={ShowNoofTraineeAlert}
            helperText={ShowNoofTraineeAlert ? "Please enter a value that is a multiple of 4" : "Enter number of trainees in multiples of 4"}
            InputProps={{
              inputProps: {
                min: 4,
              },
            }}
            onChange={handleChange1}
            onKeyPress={handle_budgetKeyPress}
            required
            autoComplete="name"
          />
        </Grid>
        <Grid item xs={12}>
          <InputLabel>
            Description<small style={{ paddingLeft: "10px" }}>(optional)</small>
          </InputLabel>
          <TextField
            fullWidth
            name="description"
            id="description"
            onChange={handleDescriptionChange}
            required
            autoComplete="family-name"
          />
        </Grid>
      </Grid>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          pt: 2,
        }}
      >
        <div>
          <Tooltip title="Cancel and discard changes">
            <span>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleReload}
                className={classes}
                sx={{ borderRadius: '50px' }}
              >
                Cancel
              </Button>
            </span>
          </Tooltip>
        </div>
        <div>
          <Tooltip title={isNextButtonDisabled ? "Please fill in all required fields" : "Proceed to the next step"}>
            <span>
              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                className={classes}
                disabled={isNextButtonDisabled}
                sx={{ borderRadius: '50px' }}
              >
                Next
              </Button>
            </span>
          </Tooltip>
        </div>
      </Box>
    </React.Fragment>
  );
}